import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const TableUserNameWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const UserNameAndBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
`
